// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "@babel/polyfill";
import Vue from 'vue'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'

Vue.use(BootstrapVue);

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'

Vue.config.productionTip = false;

import axios from 'axios'

export const globalStore = new Vue({
    data: {
        authed: false,
        group: 0,
        firstName: '',
        lastName: '',
        currentLanguage: '',
        translations: []
    },
    methods: {
        translate: function () {
            if (arguments.length === 1) {
                return this.translations[arguments[0]];
            } else {
                let key = arguments[0];
                let text = this.translations[key];

                // This can happen if the translations haven't been loaded yet
                if (!text) {
                    return;
                }

                for (let i = 1; i < arguments.length; i++) {
                    text = text.replace('{}', arguments[i]);
                }

                return text;
            }
        },
        loadTranslation: function (lang) {
            if (this.currentLanguage === lang) {
                return;
            }

            if (lang !== 'de') {
                lang = 'en';
            }

            this.currentLanguage = lang;

            axios.get("https://drop.rautec.de/static/languages/" + lang + ".json").then(response => {
                this.translations = response.data;
            });
        }
    }
});

Vue.filter('translate', function (key, ...args) {
    return globalStore.translate.apply(this, [key].concat(args));
});

Vue.filter('bytes', function (value) {
    if (value === 0) {
        return '0 B';
    }

    let i = Math.floor(Math.log(value) / Math.log(1024));
    return (value / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'KB', 'MB', 'GB', 'TB'][i];
});

Vue.filter('date', function (value) {
    let date = new Date(value * 1000);

    return date.toLocaleDateString(globalStore.currentLanguage);
});

// TODO: Combine the two date filters
Vue.filter('date2', function (value) {
    let date = new Date(value);

    return date.toLocaleDateString(globalStore.currentLanguage);
});

Vue.filter('decimals', function (value) {
    return value.toFixed(2);
});

Vue.prototype.$globalStore = globalStore;
Vue.prototype.$toast = function (body, variant) {
    this.$bvToast.toast(body, {
        title: 'Drop',
        toaster: 'b-toaster-top-center',
        variant: variant,
        solid: true,
        appendToast: true,
        autoHideDelay: 2500
    })
};
Vue.prototype.$toastSuccess = function (body, translate = false) {
    this.$toast(translate ? globalStore.translate(body) : body, 'success');
};
Vue.prototype.$toastError = function (body, translate = false) {
    this.$toast(translate ? globalStore.translate(body) : body, 'danger');
};

axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (error.response.status === 403) {
        globalStore.authed = false;
        globalStore.group = 0;

        // Only route back to home if the current route is not download password/
        if (!router.currentRoute.path.startsWith("/download") &&
            !router.currentRoute.path.startsWith("/password/") &&
            !router.currentRoute.path.startsWith("/upload/")) {
            router.push('/');
        }
    }
    return Promise.reject(error);
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: {App},
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js